import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'priceFormat',
  pure: false
})
export class PriceFormatPipe implements PipeTransform {

  transform(price: number | null, currency$: any): any {
      if (price !== null && !isNaN(price)) {
        if(typeof(price)=='string'){
            price=+price
        }
        // Format price to two decimal places
        const formatter = new Intl.NumberFormat('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        })
        const formattedPrice = formatter.format(Number(price.toFixed(2)));
        if(currency$ == '€'){
          return `${currency$} ${formattedPrice}`;
        }
        else {
          return `${formattedPrice} ${currency$}`;
        }
      } else {
        return '';
      }
    };
  
}

